export default "__VITE_ASSET__BowYdG0Y__"